import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    getSuggestions: (context, data) => {
        return Axios.post((<any>window).App.routes.TechInfo_GetSuggestions, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};